module.exports = __webpack_public_path__ + "static/img/load.4b54127.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sy/load.gif
// module id = vYbS
// module chunks = 182